import React, { useState } from 'react';
import { DriverCopy, TG_SUPPORT } from './driverI18n';
import { DriverHeader } from './DriverHeader';
import { DriverLegalLinks, DriverLegalModal } from './DriverLegalModal';

interface Props {
  t: DriverCopy;
  onBack: () => void;
}

export const DriverHelpPage: React.FC<Props> = ({ t, onBack }) => {
  const [open, setOpen] = useState<number | null>(0);
  const [legalId, setLegalId] = useState<string | null>(null);

  return (
    <div className="app-container driver-cabinet">
      <DriverHeader t={t} title={t.help} onBack={onBack} />
      <main className="main-content driver-main">
        <h3 className="driver-history-title">{t.legalTitle}</h3>
        <DriverLegalLinks t={t} onOpen={setLegalId} />
        <div className="driver-faq">
          {t.faq.map((item, index) => {
            const expanded = open === index;
            return (
              <div key={item.q} className={`driver-faq-item${expanded ? ' open' : ''}`}>
                <button
                  type="button"
                  className="driver-faq-q"
                  onClick={() => setOpen(expanded ? null : index)}
                  aria-expanded={expanded}
                >
                  {item.q}
                  <span>{expanded ? '−' : '+'}</span>
                </button>
                {expanded && <p className="driver-faq-a">{item.a}</p>}
              </div>
            );
          })}
        </div>
        <a className="btn-apply driver-support-btn" href={TG_SUPPORT} target="_blank" rel="noreferrer">
          {t.support}
        </a>
      </main>
      <DriverLegalModal t={t} docId={legalId} onClose={() => setLegalId(null)} />
    </div>
  );
};
